<template>
  <div class="ticket--connected">
    <div class="ticket-box">
      <span v-if="isTicketExpired" class="tag">期限切れ</span>
      <span class="ticket-image">
        <img :src="imageUrl" />
      </span>
      <div class="ticket-info">
        <p class="ticket__brand--small">
          {{ brandName }}
        </p>
        <p class="ticket__item-name">
          {{ itemName }}
        </p>
        <p class="ticket__item-min-unit">
          {{ itemSkuName }}
        </p>
        <span class="ticket__expired-date">{{ expiredDate + 'まで有効' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    expiredDate: {
      type: String,
      required: true
    },
    isTicketExpired: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  &--connected {
    font-size: 1.6rem;
    line-height: 1.6;
    color: $black;
    text-decoration: none;
    width: 100%;
    display: block;
    background-color: transparent;
  }

  &-box {
    height: 88px;
    display: flex;
  }

  &-image {
    height: 100%;
    font-size: 0;
  }

  &-image img {
    height: 72px;
    border-radius: 8px;
    width: 72px;
  }

  &-info {
    overflow: hidden;
    width: 100%;
    padding: 0 28px 0 16px;
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__item-name {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 2px;
    color: $black;
  }

  &__item-min-unit {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 2px;
    color: $black;
  }

  &__brand--small {
    line-height: 1.6;
    color: $gray-1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    font-size: 1rem;
    padding-bottom: 2px;
  }

  &__expired-date {
    font-size: 1rem;
    color: $gray-1;
    padding-top: 0;
    text-align: left;
    right: 0;
    line-height: 1.4;
  }
}
</style>
